export const AboutMe = [
    {
        style: { width: '6.5em' },
        src: require('../img/charts.jpg'),
        altText: 'Slide 1',
        key: 1

    },
    {
        style: { width: '6.5em' },
        src: require('../img/bshaw.jpg'),
        altText: 'Slide 2',
        key: 2,

    },
    {
        style: { width: '6.5em' },
        src: require('../img/me.jpg'),
        altText: 'Slide 3',
        key: 3,

    },
    {
        style: { width: '6.5em' },
        src: require('../img/rail.jpg'),
        altText: 'Slide 4',
        key: 4,

    },
    {
        style: { width: '6.5em' },
        src: require('../img/jetPack.gif'),
        altText: 'Slide 5',
        key: 5,

    },
];